import { PlusIcon } from "@phosphor-icons/react";
import { Button } from "@bednbody/ui/components/button";
import { PageHeader } from "@bednbody/ui/components/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@bednbody/ui/components/tabs";
import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { ManualOrderDialog } from "./OrderDialogs";
import { OrdersTab } from "./OrdersTab";
import { PackagesTab } from "./PackagesTab";
import { PrintQueueTab } from "./PrintQueueTab";

/**
 * GiftPass orders (G7, G8; spec docs/specs/giftpass-admin.md). Admin and
 * superadmin read everything; creating, marking paid, cancelling and editing
 * packages are Superadmin only (Leon, 2026-10-26) — the server enforces it,
 * the page only hides what it would refuse.
 */
export function GiftpassOrdersPage() {
  const { claims } = useAuth();
  const isSuper = claims?.role === "superadmin";
  const [tab, setTab] = useState("orders");
  const [creating, setCreating] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <PageHeader
        title="GiftPass orders"
        description="Online and manual orders, their codes, printed cards and the packages on sale."
        actions={
          isSuper ? (
            <Button onClick={() => setCreating(true)}>
              <PlusIcon data-icon="inline-start" /> New manual order
            </Button>
          ) : null
        }
      />

      <Tabs value={tab} onValueChange={(value) => setTab(String(value))}>
        <TabsList>
          <TabsTrigger value="orders">Orders</TabsTrigger>
          <TabsTrigger value="print">Print queue</TabsTrigger>
          <TabsTrigger value="packages">Packages</TabsTrigger>
        </TabsList>
        <TabsContent value="orders" className="pt-4">
          <OrdersTab isSuper={isSuper} selected={selected} onSelect={setSelected} />
        </TabsContent>
        <TabsContent value="print" className="pt-4">
          <PrintQueueTab />
        </TabsContent>
        <TabsContent value="packages" className="pt-4">
          <PackagesTab isSuper={isSuper} />
        </TabsContent>
      </Tabs>

      <ManualOrderDialog
        open={creating}
        onOpenChange={setCreating}
        onCreated={(orderId) => {
          setTab("orders");
          setSelected(orderId);
        }}
      />
    </div>
  );
}
